import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import { ThemeContext } from "@emotion/core";
import { compose, margin as parseMarginProp, system } from "styled-system";
import Box from "./Box"; // We use this styled-system function to get responsive values for the non-existent
// CSS property "direction". We check for this property in `createStackedStyles`
// to return the correct CSS.

var parseDirectionProp = system({
  direction: true
});
var parseProps = compose(parseDirectionProp, parseMarginProp); // This transforms output of `parseDirectionProp` and styled-system's `margin` function
// into the correct CSS output with media queries.

export function createStackedStyles(parsedProps) {
  if (parsedProps == null) return {};

  var direction = parsedProps.direction,
      margin = parsedProps.margin,
      mediaQueries = _objectWithoutPropertiesLoose(parsedProps, ["direction", "margin"]);

  var styles = {};
  Object.keys(mediaQueries).forEach(function (mediaQuery) {
    var _extends2;

    styles = _extends({}, styles, (_extends2 = {}, _extends2[mediaQuery] = createStackedStyles(mediaQueries[mediaQuery]), _extends2));
  });

  if (direction === "row") {
    return _extends({
      display: "flex",
      "> *:not(:last-child)": {
        marginRight: margin,
        marginBottom: 0
      }
    }, styles);
  }

  return _extends({
    display: "block",
    "> *:not(:last-child)": {
      marginRight: 0,
      marginBottom: margin
    }
  }, styles);
}

function getResponsiveValueType(value) {
  if (typeof value !== "object") return ["value", undefined];
  if (Array.isArray(value)) return ["array", value.length];
  return ["object", Object.keys(value).sort().join()];
}

function responsiveValueTypesMatch(left, right) {
  var _getResponsiveValueTy = getResponsiveValueType(left),
      leftType = _getResponsiveValueTy[0],
      leftBreakpoints = _getResponsiveValueTy[1];

  var _getResponsiveValueTy2 = getResponsiveValueType(right),
      rightType = _getResponsiveValueTy2[0],
      rightBreakpoints = _getResponsiveValueTy2[1];

  return leftType === rightType && leftBreakpoints === rightBreakpoints;
}

export default function StackView(_ref) {
  var direction = _ref.direction,
      spacing = _ref.spacing,
      props = _objectWithoutPropertiesLoose(_ref, ["direction", "spacing"]);

  if (process.env.NODE_ENV === "development") {
    if (!responsiveValueTypesMatch(direction, spacing)) {
      // eslint-disable-next-line no-console
      console.warn("StackView: The breakpoints of `direction` and `spacing` must match for consistent results.");
    }
  }

  return ___EmotionJSX(ThemeContext.Consumer, null, function (theme) {
    var parsedProps = parseProps({
      margin: spacing,
      direction: direction,
      theme: theme
    });
    var styles = createStackedStyles(parsedProps);
    return ___EmotionJSX(Box, _extends({
      css: styles
    }, props));
  });
}
StackView.defaultProps = {
  direction: "column",
  alignItems: "center"
};